export default __webpack_public_path__ + "static/media/image-2-m.ebe5a6d4.webp";